<div class="admin-container">

  <mat-label>Approval Admins</mat-label><br/>
  @if (!isEmtpy) {
    <div class="email-contrainer">
      @for (admin of admins; track admin; let isLast = $last) {
        <span>
          <a [href]="admin.email">{{ admin.name }}</a>
          @if (!isLast) {
            <span>, </span>
          }
        </span>
      }
    </div>
  } @else {
    <div class="well-info-item">
      <span>N/A</span>
    </div>
  }
</div>
